import { Link } from "react-router-dom";
import LogoFooter from "../images/botlogo.png";
import { useEffect, useState } from "react";
import FooterLink from "./FooterLink.component";
const Footer = () => {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    try {
      const fetchData = async () => {
        const res = await fetch("https://htadmin.biandanbao.com/api/links");
        const data = await res.json();
        console.log(data);
        setLinks(data.data);
      };
      fetchData();
    } catch (error) {
      console.log(error);
    }
  }, []);
  return (
    <footer className="mt-[79px] pt-[25px] w-full bg-[#313131] flex flex-col font-['Roboto_Mono']">
      <div className="footer-wrap w-[1200px] mx-auto flex flex-row pb-[35px] justify-between">
        {/* Column 1: BIAN官方频道 & BIAN官方群组 */}
        <div className="footer-left flex flex-col">
          <div>
            <p className="text-[#fff] text-[16px] font-bold mb-[12px]">
              BIAN官方频道
            </p>
            <div className="flex flex-col space-y-[8px] text-[#a6a6a6] text-[14px]">
              <p>官方频道 @BIAN 公告通知</p>
              <p>纠纷仲裁 @UBER 防骗曝光</p>
              <p>必安公群 @BAGQ 静态导航</p>
              <p>必安供需 @BAGX 付费广告</p>
              <p>纠纷仲裁 @UBER 防骗曝光</p>
              <p>币安公群 @DJDJ 公群导航</p>
              <p>币安供需 @PRON 付费广告</p>
              <p>机场代理 @JiChang</p>
              <p>币游官方 @coingaming</p>
            </div>
          </div>
          <div className="mt-[24px]">
            <p className="text-[#fff] text-[16px] font-bold mb-[12px]">
              BIAN官方群组
            </p>
            <div className="flex flex-col space-y-[8px] text-[#a6a6a6] text-[14px]">
              <p>茶余饭后 @TTTV</p>
              <p>游戏交流 @YABO</p>
            </div>
          </div>
        </div>

        {/* Column 2: 必安担保工作人员 & 币安担保工作人员 & 币游娱乐工作人员 */}
        <div className="footer-center flex flex-col">
          <div>
            <p className="text-[#fff] text-[16px] font-bold mb-[12px]">
              必安担保工作人员
            </p>
            <div className="grid grid-cols-3 gap-x-[36px] gap-y-[8px] text-[#a6a6a6] text-[14px]">
              <p>公群负责人 @CPDD</p>
              <p>纠纷仲裁 @ZOOM</p>
              <p>专群客服 @YUYU</p>
              <p>供需负责人 @ZARA</p>
              <p>纠纷仲裁 @SCZL</p>
              <p>群管场控 @SEDO</p>
              <p>币总宣传部 @BiLL</p>
              <p>纠纷接待 @ORDI</p>
            </div>
          </div>

          <div className="mt-[24px]">
            <p className="text-[#fff] text-[16px] font-bold mb-[12px]">
              币安担保工作人员
            </p>
            <div className="grid grid-cols-3 gap-x-[36px] gap-y-[8px] text-[#a6a6a6] text-[14px]">
              <p>公群负责人 @TUSD</p>
              <p>纠纷仲裁 @TELO</p>
              <p>专群客服 @GBPT</p>
              <p>供需负责人 @SIWA</p>
            </div>
          </div>

          <div className="mt-[24px]">
            <p className="text-[#fff] text-[16px] font-bold mb-[12px]">
              币游娱乐工作人员
            </p>
            <div className="grid grid-cols-3 gap-x-[36px] gap-y-[8px] text-[#a6a6a6] text-[14px]">
              <p>币游负责人 @ZALO</p>
              <p>币游客服 @QIQU</p>
              <p>币游客服 @QIMIAO</p>
            </div>
          </div>
        </div>

        {/* Column 3: 投诉举报/意见建议/商务合作 & 币安机器人 */}
        <div className="footer-right flex flex-col">
          <div>
            <p className="text-[#fff] text-[16px] font-bold mb-[12px]">
              投诉举报/意见建议/商务合作
            </p>
            <div className="flex flex-col space-y-[8px] text-[#a6a6a6] text-[14px]">
              <p>币安监督 @JianDu</p>
              <p>币安监察 @JianCha</p>
            </div>
          </div>

          <div className="mt-[24px]">
            <p className="text-[#fff] text-[16px] font-bold mb-[12px]">
              币安机器人
            </p>
            <div className="flex flex-col space-y-[8px] text-[#a6a6a6] text-[14px]">
              <p>唯一验证 @BADB</p>
              <p>游戏钱包 @HPAY</p>
              <p>抽奖钱包 @PPAY</p>
              <p>卧龙群管 @WoLong</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#232323] flex flex-col pt-[15px]">
        <img
          src={LogoFooter}
          width="150px"
          height={`35px`}
          className="self-center"
        />
        <div className="self-center text-[#ffffff] my-[10px]">
          <Link to="/config?key=yszc">隐私政策</Link> ｜
          <Link to="/config?key=gszs">公司证书</Link>｜
          <Link to="/config?key=yyzz">营业执照</Link> ｜
          <Link to="/config?key=flsm">法律声明</Link>
        </div>
        <div className="self-center text-[#ce8f19] my-[10px] text-[12px]">
          郑重声明：客户应自行遵守所在国家和地区的法律法规。如因客户行为违反相关法律法规，所引发的一切责任和后果均由客户自行承担，BiAn不承担任何责任。
        </div>
      </div>
      <div className="flex flex-col items-center bg-[#313131] text-[#a1a1a1] py-[15px]">
        <p>Copyright © 2023-2024 BADB All Rights Reserved </p>
        <p>A company of BiAn Co., Ltd</p>
        {/* <div className="flex flex-row gap-[10px] text-[#ce8f19]">
          {links && links.length > 0 && (
            <>
              <span>友情链接：</span>
              <FooterLink list={links} />
            </>
          )}
        </div> */}
      </div>
    </footer>
  );
};
export default Footer;
